export default __webpack_public_path__ + "52350aedb73f6ad6aea0cc578b9241e7.svg";